var _rect, _rect2, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCheckbox(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    rx: 8,
    fill: "#E0E0E0"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1019_166021)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1019_166021",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 12,
    height: 12
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 12,
    height: 12,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1019_166021)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.77534 10.8625C6.70034 10.8625 6.62951 10.85 6.56284 10.825C6.49618 10.8 6.43368 10.7583 6.37534 10.7L4.22534 8.55C4.11701 8.44167 4.06501 8.30617 4.06934 8.1435C4.07334 7.98117 4.12951 7.84583 4.23784 7.7375C4.34618 7.62917 4.48168 7.575 4.64434 7.575C4.80668 7.575 4.93784 7.62917 5.03784 7.7375L6.77534 9.475L10.9628 5.2875C11.0628 5.17917 11.1962 5.125 11.3628 5.125C11.5295 5.125 11.667 5.17917 11.7753 5.2875C11.8753 5.39583 11.9253 5.53117 11.9253 5.6935C11.9253 5.85617 11.8753 5.99167 11.7753 6.1L7.17534 10.7C7.11701 10.7583 7.05451 10.8 6.98784 10.825C6.92118 10.85 6.85034 10.8625 6.77534 10.8625Z",
    fill: "#949494"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1019_166021"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(2 2)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckbox);
export default __webpack_public_path__ + "static/media/Checkbox.1c1df0626456c849503e970a864741b2.svg";
export { ForwardRef as ReactComponent };